'use strict';
import moment from 'moment';

import { Match } from 'models/Match';
import { DateFormat } from 'components/DateFormat';
import { CacheableDataObject } from 'models/CacheableDataObject';
import { Users } from './UserCollection';

export default class Infraction extends CacheableDataObject {

	static convert(infractions, user) {
		const list = [];
		_.each(infractions, (infraction) => {
			list.push(Infraction.create(infraction));
		});
		return list;
	}

	beforeConstruct(infraction) {
		this.public_message = null;
		this.match = null;
		this.timestamp = null;
	}

	editUrl() {
		return `${siteUrl}/mod/infractions/view/${this.id}`;
	}

	getReportUrl() {
		return `${siteUrl}/mod_reports/detail/${this.bug_id}`;
	}
}

Infraction.prototype.dataLocationParsers = {
	assigned_by: (infraction, data) => {
		infraction.assigned_by = Users.update(data.assigned_by);
	},
	assigned_to: (infraction, data) => {
		infraction.assigned_to = Users.update(data.assigned_to);
	},
	timestamp: (infraction, data) => {
		infraction.timestamp = DateFormat.momentFromLadderTime(data.timestamp);
	},
	match: (infraction, data) => {
		infraction.match = Match.retrieve(data.match);
	},
	created_at: (infraction, data) => {
		infraction.created_at = moment.unix(data.created_at);
	},
	referred_player: (infraction, data) => {
		infraction.referred_player = Users.update(data.referred_player);
	},
	report: (infraction, data) => {
		infraction.report = _.cloneDeep(data.report);
		if(infraction.report.reporter) {
			infraction.report.reporter = Users.update(infraction.report.reporter);
		}
		if(infraction.report.reported) {
			infraction.report.reported = Users.update(infraction.report.reported);
		}
	}
};